const UUID_PREFIX =
  /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;

export function fileShareKey(storedName) {
  const match = String(storedName || '').match(UUID_PREFIX);
  return match ? match[1] : String(storedName || '');
}

export function fileMatchesShareKey(storedName, key) {
  if (!storedName || !key) return false;
  if (storedName === key) return true;
  return fileShareKey(storedName) === key;
}

export function findPublicShareAncestor(folders, folderId) {
  const byId = new Map((folders || []).map((f) => [f.id, f]));
  let cur = byId.get(folderId);
  while (cur) {
    if (cur.publicShareEnabled) return cur;
    cur = cur.parentId ? byId.get(cur.parentId) : null;
  }
  return null;
}

export function buildPublicFolderShareUrl(origin, shareToken, { folderId, storedNames, openGallery, includeSubfolders } = {}) {
  const params = new URLSearchParams();
  params.set('publicFolder', shareToken);
  if (folderId) params.set('folder', folderId);
  for (const name of storedNames || []) {
    const key = fileShareKey(name);
    if (key) params.append('file', key);
  }
  if (openGallery) params.set('gallery', '1');
  if (includeSubfolders) params.set('subfolders', '1');
  const base = String(origin || '').replace(/\/$/, '');
  return `${base}/?${params.toString()}`;
}

export async function copyTextToClipboard(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy path (e.g. non-secure origins)
  }
  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}
